// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1i1ZI","content":"styles_content__ESv_a","selectAll":"styles_selectAll__22yU0"};